import { render, staticRenderFns } from "./CardWidget.vue?vue&type=template&id=0930db01"
import script from "./CardWidget.vue?vue&type=script&lang=js"
export * from "./CardWidget.vue?vue&type=script&lang=js"
import style0 from "./CardWidget.vue?vue&type=style&index=0&id=0930db01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports